(function () {
  'use strict';
  var cfg = JSON.parse(document.getElementById('eu-order-config').textContent);
  var rootUrl = (window.Shopify && Shopify.routes.root) || '/';
  function quantity(section) {
    var el = document.getElementById('Quantity-' + section);
    return el ? Number(el.value) : 0;
  }
  function setQuantity(section, value) {
    ['Quantity-', 'Quantity-sticky-'].forEach(function (prefix) {
      var el = document.getElementById(prefix + section);
      if (!el) return;
      el.value = value;
      el.dispatchEvent(new Event('input', {bubbles: true}));
      el.dispatchEvent(new Event('change', {bubbles: true}));
    });
  }
  function selected(root, group) {
    return Array.from(root.querySelectorAll('[data-eu-choice="' + group + '"]:checked')).map(function (input) { return input.value; });
  }
  function allocate(root) {
    var container = root.querySelector('[data-eu-allocation]');
    var scents = selected(root, 'scent');
    var qty = quantity(root.dataset.section);
    var signature = JSON.stringify([scents, qty]);
    if (container.dataset.signature === signature) return;
    var old = {};
    container.querySelectorAll('input').forEach(function (el) { old[el.dataset.scent] = el.value; });
    var sameQty = container.dataset.quantity === String(qty) && container.dataset.scents === JSON.stringify(scents);
    container.replaceChildren();
    scents.forEach(function (scent, index) {
      var label = document.createElement('label');
      label.className = 'eu-allocation-row';
      label.append(document.createTextNode(scent + ' — ' + cfg.pieces));
      var input = document.createElement('input');
      input.type = 'number'; input.min = '1'; input.step = '1'; input.inputMode = 'numeric';
      input.dataset.scent = scent;
      input.value = sameQty && old[scent] !== undefined ? old[scent] : Math.floor(qty / scents.length) + (index < qty % scents.length ? 1 : 0);
      label.append(input); container.append(label);
    });
    container.dataset.signature = signature; container.dataset.quantity = String(qty); container.dataset.scents = JSON.stringify(scents);
  }
  function init() {
    document.querySelectorAll('[data-eu-multi]').forEach(allocate);
    document.querySelectorAll('[data-eu-bundles]').forEach(function (root) {
      var checked = root.querySelector('input:checked');
      if (![75, 100].includes(quantity(root.dataset.section))) setQuantity(root.dataset.section, Number(checked.value));
      var product = root.closest('[id^="x-product-template-"]');
      var price = Number(product && product.querySelector('.target-price')?.textContent);
      if (!Number.isFinite(price)) return;
      var output = root.querySelector('[data-eu-bundle-total]');
      var value = new Intl.NumberFormat(cfg.locale, {style: 'currency', currency: cfg.currency}).format(price * Number(checked.value) / 100);
      if (output.textContent !== value) output.textContent = value;
    });
  }
  window.EuphoriaOrder = {
    prepare: function (formData, form) {
      // Only the main or sticky form for this exact section owns its customisation.
      var section = (form.getAttribute('id') || '').replace(/^product-form-(?:sticky-)?/, '');
      var product = form.closest('[id^="x-product-template-"]');
      if (!product) return;
      product?.querySelectorAll('[data-eu-order-property]').forEach(function (input) { if (input.value.trim()) formData.set(input.name, input.value.trim()); });
      var bundle = product?.querySelector('[data-eu-bundles]');
      if (bundle) {
        var qty = Number(bundle.querySelector('input:checked')?.value);
        if (![75, 100].includes(qty)) throw new Error(cfg.invalid);
        formData.set('quantity', qty);
        formData.set('properties[' + cfg.bundle + ']', qty === 75 ? cfg.bundle75 : cfg.bundle100);
        formData.set('properties[_euphoria_bundle_id]', crypto.randomUUID());
      }
      var multi = product?.querySelector('[data-eu-multi]');
      if (!multi) return;
      allocate(multi);
      var tags = selected(multi, 'tag');
      var scents = selected(multi, 'scent');
      var counts = Array.from(multi.querySelectorAll('[data-eu-allocation] input'));
      var qty = quantity(multi.dataset.section);
      var valid = scents.length > 0 && (multi.dataset.product !== '8229295226937' || tags.length > 0) && counts.every(function (el) { return Number.isInteger(Number(el.value)) && Number(el.value) > 0; }) && counts.reduce(function (sum, el) { return sum + Number(el.value); }, 0) === qty;
      multi.querySelector('[data-eu-choice-error]').hidden = valid;
      if (!valid) { multi.scrollIntoView({block: 'center', behavior: 'smooth'}); throw new Error(cfg.invalid); }
      formData.set('quantity', qty);
      formData.set('properties[_euphoria_configuration_id]', crypto.randomUUID());
      if (tags.length) formData.set('properties[' + cfg.tag + ']', tags.join(' + '));
      formData.set('properties[' + cfg.scents + ']', scents.join(' + '));
      formData.set('properties[' + cfg.allocation + ']', counts.map(function (el) { return el.dataset.scent + ': ' + el.value; }).join(' | '));
    },
    rollbackPartial: async function (formData) {
      var propertyKey = formData.has('properties[_euphoria_bundle_id]') ? '_euphoria_bundle_id' : '_euphoria_configuration_id';
      var bundleId = formData.get('properties[' + propertyKey + ']');
      if (!bundleId) return;
      var response = await fetch(rootUrl + 'cart.js');
      if (!response.ok) throw new Error(cfg.failed);
      var cart = await response.json();
      var line = cart.items.find(function (item) { return item.properties?.[propertyKey] === bundleId; });
      if (!line || line.quantity === Number(formData.get('quantity'))) return;
      var removal = await fetch(rootUrl + 'cart/change.js', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({id: line.key, quantity: 0})});
      if (!removal.ok) throw new Error(cfg.failed);
      await Alpine.store('xCartHelper').reRenderSections();
    }
  };
  document.addEventListener('change', function (event) {
    var bundle = event.target.closest('[data-eu-bundles]');
    if (bundle) setQuantity(bundle.dataset.section, Number(event.target.value));
    init();
    var select = event.target.closest('[data-eu-cart-bundle]');
    if (!select || select.disabled) return;
    var qty = Number(select.value);
    if (![75, 100].includes(qty)) { select.value = select.dataset.previous; return; }
    select.disabled = true;
    (async function () {
      var helper = Alpine.store('xCartHelper');
      await helper.waitForCartUpdate(); window.updatingCart = true;
      try {
        var properties = JSON.parse(select.dataset.properties);
        properties[cfg.bundle] = qty === 75 ? cfg.bundle75 : cfg.bundle100;
        var response = await fetch(rootUrl + 'cart/change.js', {method: 'POST', headers: {'Content-Type': 'application/json'}, body: JSON.stringify({id: select.dataset.key, quantity: qty, properties: properties, sections: helper.getSectionsToRender().map(function (s) {return s.id;}), sections_url: location.pathname})});
        var cart = await response.json();
        if (!response.ok || cart.status) throw new Error(cart.description || cfg.failed);
        await helper.reRenderSections(cart.sections); helper.currentItemCount = cart.item_count;
        document.dispatchEvent(new CustomEvent('eurus:cart:items-changed'));
      } catch (error) { select.value = select.dataset.previous; alert(error.message || cfg.failed); }
      finally { select.disabled = false; window.updatingCart = false; }
    })();
  });
  document.addEventListener('input', function (event) { if (event.target.name === 'quantity') init(); });
  document.addEventListener('DOMContentLoaded', init);
  var queued = false;
  new MutationObserver(function () { if (queued) return; queued = true; requestAnimationFrame(function () {queued = false; init();}); }).observe(document.documentElement, {childList: true, subtree: true});
  init();
})();
